"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GlobalFooter = _interopRequireDefault(require("eventbrite_design_system/globalFooter/GlobalFooter"));

var _Illustration = _interopRequireDefault(require("eventbrite_design_system/illustration/Illustration"));

var _constants = require("./constants");

var utils = _interopRequireWildcard(require("./utils"));

var _MarketingSection = _interopRequireDefault(require("./MarketingSection"));

var _BrandSuperCropIllustration = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/BrandSuperCropIllustration"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SiteFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(SiteFooter, _React$Component);

  var _super = _createSuper(SiteFooter);

  function SiteFooter() {
    _classCallCheck(this, SiteFooter);

    return _super.apply(this, arguments);
  }

  _createClass(SiteFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          thirdFooterColumn = _this$props.thirdFooterColumn,
          thirdFooterColumnName = _this$props.thirdFooterColumnName,
          eventsToPlan = _this$props.eventsToPlan,
          serverUrl = _this$props.serverUrl,
          locales = _this$props.locales,
          localeInfo = _this$props.localeInfo,
          helpLinks = _this$props.helpLinks,
          onLocaleChange = _this$props.onLocaleChange,
          popularSearches = _this$props.popularSearches,
          showBrand = _this$props.showBrand,
          showMinimalLinks = _this$props.showMinimalLinks,
          showMarketingLinks = _this$props.showMarketingLinks;
      var generalLinks;
      var brandSection;
      var marketingSection;

      if (showMinimalLinks) {
        generalLinks = utils.getMinimalGeneralLinks(serverUrl);
      } else {
        generalLinks = utils.getGeneralLinks(serverUrl, localeInfo, helpLinks);
      }

      if (showBrand) {
        brandSection = /*#__PURE__*/_react.default.createElement(_Illustration.default, {
          type: /*#__PURE__*/_react.default.createElement(_BrandSuperCropIllustration.default, null),
          width: "100%",
          height: "auto"
        });
      }

      if (showMarketingLinks) {
        marketingSection = /*#__PURE__*/_react.default.createElement(_MarketingSection.default, {
          serverUrl: serverUrl,
          popularSearches: popularSearches,
          eventsToPlan: eventsToPlan,
          thirdFooterColumn: thirdFooterColumn,
          thirdFooterColumnName: thirdFooterColumnName,
          localeInfo: localeInfo
        });
      }

      var formattedLocales = utils.getLocales(locales);
      return /*#__PURE__*/_react.default.createElement(_GlobalFooter.default, {
        generalLinks: generalLinks,
        locales: formattedLocales,
        currentLocale: localeInfo.locale,
        onLocaleChange: onLocaleChange,
        brandSection: brandSection,
        flexibleSection: marketingSection
      });
    }
  }]);

  return SiteFooter;
}(_react.default.Component);

exports.default = SiteFooter;

_defineProperty(SiteFooter, "propTypes", {
  serverUrl: _propTypes.default.string.isRequired,
  locales: _constants.LOCALES_ARRAY_PROP_TYPE.isRequired,
  localeInfo: _constants.LOCALE_INFO_SHAPE_PROP_TYPE.isRequired,
  popularSearches: _constants.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  eventsToPlan: _constants.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumn: _constants.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumnName: _propTypes.default.string.isRequired,
  countries: _constants.COUNTRIES_ARRAY_PROP_TYPE.isRequired,
  helpLinks: _constants.HELP_LINKS_PROP_TYPE.isRequired,
  onLocaleChange: _propTypes.default.func,
  isUserAuthenticated: _propTypes.default.bool,
  showMinimalLinks: _propTypes.default.bool,
  showMarketingLinks: _propTypes.default.bool,
  showBrand: _propTypes.default.bool
});
//# sourceMappingURL=SiteFooter.js.map